"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsyncFn = void 0;
const React = __importStar(require("react"));
const use_mounted_state_1 = require("./use-mounted-state");
function useAsyncFn(fn, deps = [], initialState = { loading: false }) {
    const lastCallId = React.useRef(0);
    const isMounted = (0, use_mounted_state_1.useMountedState)();
    const [state, setState] = React.useState(initialState);
    const callback = React.useCallback((...args) => {
        const callId = ++lastCallId.current;
        if (!state.loading) {
            setState(prevState => ({ ...prevState, loading: true }));
        }
        return fn(...args).then(value => {
            isMounted() &&
                callId === lastCallId.current &&
                setState({ value, loading: false });
            return value;
        }, error => {
            isMounted() &&
                callId === lastCallId.current &&
                setState({ error, loading: false });
            return Promise.reject(error);
        });
    }, deps);
    return [state, callback];
}
exports.useAsyncFn = useAsyncFn;
//# sourceMappingURL=use-async-fn.js.map